<script setup lang="ts">
import GlobalData from "@/GlobalData";
import auth from "@/auth";
import { useAuthenticationStore } from "@/stores/authentication";
import { useRouter } from "vue-router";
import { useAuditStore } from "@/stores/audit";

const router = useRouter();
const authenticationStore = useAuthenticationStore();
const audit = useAuditStore();
auth
  .signinCallback()
  .then((user) => {
    useAuthenticationStore().setUser(user || null);
  })
  .catch((error) => {
    console.log("Redirect Error", error);
    GlobalData.getInstance().errorMessage.setErrorStatus(404);
    // authenticationStore.removeUser();
    GlobalData.getInstance().hasErrorPage = true;
    router.push({ name: "error" });
  })
  .finally(() => {
    authenticationStore.decodeJwt();
    audit.auditLog("Login");
    if (useAuthenticationStore().userRole == 1) {
      router.push({ name: "agencylist" });
    } else router.push({ name: "search" });
  });
</script>

<template></template>
